import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from 'axios';
import logo from "../media/TCOpfingen_Logo.png";
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../provider/auth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../App.js';

function Login() {
    const { login, user} = useAuth();
    const [values, setValues] = useState({ email: "", password: "" });
    const [forgotPassword, setForgotPassword] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const navigate = useNavigate()
    

    if(user) {
        navigate("/booking")
    }

    const handleLogin = async (event) => {
        event.preventDefault();
        await login(values.email, values.password);
    };

    const handleReset = async (event) => {
        event.preventDefault();
        const formData = { email: values.email };
        try {
            await axios.post(`${API_BASE_URL}/api/password-reset`, formData);
            toast.success("Email versendet. Überprüfe auf neue Nachrichten")
            setForgotPassword(false)
        } catch (error) {
            toast.error(error.response?.data?.message || "Fehler beim Passwort zurücksetzen")
        }
    };

    const handleFocus = () => {
        setIsFocused(true); // Formular verschieben
      };
    
      const handleBlur = () => {
        setIsFocused(false); // Zurück zur ursprünglichen Position
      };

    return (
        <div className={`login ${isFocused ? 'focused' : ''} px-3 py-3 rounded shadow-lg`}>
            <div>
                <div className='d-flex justify-content-center '>
                    <img className="login-logo my-4" src={logo} alt="logo" />
                </div>
                <div>
                    {!forgotPassword ? (
                        <Form onSubmit={handleLogin} className='text-center'>
                            <div className='d-flex justify-content-center align-items-center textfield'>
                                <div>
                                    <Form.Group className="mb-3" controlId="formGroupEmail">
                                        <TextField
                                            id="email"
                                            label="Email"
                                            autoComplete="email"
                                            size="small"
                                            variant="outlined"
                                            className='bg-white-25 rounded'
                                            sx={{ width: '300px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#e53935' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: '#e53935' } } }}
                                            onFocus={handleFocus}
                                            
                                            onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formGroupPassword">
                                        <TextField
                                            id="password"
                                            label="Passwort"
                                            variant="outlined"
                                            size="small"
                                            type="password"
                                            autoComplete="current-password"
                                            sx={{ width: '300px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#e53935' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: '#e53935' } } }}
                                            className='bg-white-25 rounded'
                                            onClick={handleFocus}
                                        
                                            onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                            <div className='text-center'>
                                <Button variant="contained" color="error" type="submit">Anmelden</Button>
                            </div>
                            <p className='text-center mt-4 forgot-password' onClick={() => setForgotPassword(true)}>Passwort vergessen?</p>
                        </Form>
                    ) : (
                        <Form onSubmit={handleReset} className='text-center text-field'>
                            <div className='d-flex justify-content-center align-items-center textfield'>
                                <Form.Group className="my-3" controlId="formGroupEmail">
                                    <TextField
                                        id="email"
                                        label="Email"
                                        autoComplete="email"
                                        size="small"
                                        variant="outlined"
                                        className='bg-white-25 rounded'
                                        sx={{ width: '300px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#e53935' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: '#e53935' } } }}
                                        onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                        onClick={handleFocus}
                                        onBlur={handleBlur}
                                        required
                                    />
                                </Form.Group>
                            </div>
                            <div className='text-center'>
                                <Button variant="contained" color="error" type="submit">Passwort zurücksetzen</Button>
                            </div>
                            <p className='text-center mt-4 forgot-password' onClick={() => setForgotPassword(false)}>Zurück zum Login</p>
                        </Form>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Login;
